export default 'white25';